import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Select, Modal, Carousel } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

type fetchParams = {
    coperation_name: string | undefined,
    contact_man: string | undefined,
    contact_phone: string | undefined,
    status: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

export default function Coperation() {

    let fetchOtherParamsTmpl: fetchParams = {
        coperation_name: undefined,
        contact_man: undefined,
        contact_phone: undefined,
        status: undefined
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [data, setData] = useState<any>([])

    const [imageList, setImageList] = useState<any[]>([])
    const [imageVisble, setImageVisble] = useState<boolean>(false)

    // 页面权限
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleUrl = (el: any) => {
        setImageVisble(true)
        setImageList([el.business_license_url])
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/yuesao_center/config/coperation/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }
        }).then((response: any) => {
            let p: any = { ...pagination }
            p.total = response.total

            setPagination(p)
            setData(response.records)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 月嫂配置 -> 合作商管理 */}
        <BreadCrumb position={['月嫂中心', '合作商管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ marginRight: 8, marginBottom: 12, width: 200 }} placeholder="合作商名称" value={fetchOtherParams.coperation_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'coperation_name') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="联系人" value={fetchOtherParams.contact_man} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'contact_man') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="联系人电话" value={fetchOtherParams.contact_phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'contact_phone') }} />

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="状态" value={fetchOtherParams.status} onChange={(v: number) => { handleChange(v, 'status') }}>
                    <Option value={1} key={1}>已启用</Option>
                    <Option value={2} key={2}>已停用</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" ><Link to={"/yuesao_coperation_add"}>添加</Link></Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="coperation_id" pagination={pagination} onChange={handleTableChange}>
                <Column
                    fixed
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {permission.includes('编辑') && <Button size="small" type="primary" ><Link to={"/yuesao_coperation_edit/" + record.coperation_id}>编辑</Link></Button>}
                        </Space>
                    )}
                />

                <Column fixed title="合作商名称" dataIndex="coperation_name" key="coperation_name" />
                <Column fixed title="联系人" dataIndex="contact_man" key="contact_man" />
                <Column fixed title="联系人电话" dataIndex="contact_phone" key="contact_phone" />
                <Column
                    title="营业执照"
                    key="business_license_url"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="link" onClick={() => (handleUrl(record))}>查看</Button>
                        </Space>
                    )}
                />

                <Column title="开始日期" dataIndex="start_date" key="start_date" />
                <Column title="结束日期" dataIndex="end_date" key="end_date" />

                <Column title="员工总数" dataIndex="employee_total_num" key="employee_total_num" />
                <Column title="在职员工数" dataIndex="employee_current_num" key="employee_current_num" />
                <Column title="离职员工数" dataIndex="employee_depart_num" key="employee_depart_num" />
                <Column title="待岗员工数" dataIndex="employee_await_num" key="employee_await_num" />
                <Column title="上单员工数" dataIndex="employee_duty_num" key="employee_duty_num" />

                <Column title="状态" dataIndex="status" key="status" render={(row: any) => {
                    if (row == 1) {
                        return '已启用'

                    } else {
                        return '已停用'
                    }
                }} />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="更新人" dataIndex="update_user_name" key="update_user_name" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />
            </Table>
        </div>

        {/* 图片预览 */}
        <Modal title='营业执照' visible={imageVisble} onCancel={() => { setImageVisble(false) }} footer={null} >
            <Carousel>
                {imageList.length && imageList.map((el: any, index: any) => (
                    <img key={index} src={el}></img>
                ))}
            </Carousel>
        </Modal >
    </div>)
}